import React from 'react';
import { Layout, RoutesMenu, GetInfo } from '../../components';
import '../../assets/styles/containers/Routes.sass';

const Summary = () => {
  return (
    <div className="Summary">
      <Layout bannerId={70}>
        <RoutesMenu/>
        <div className="container">
          <GetInfo id={137}/>
        </div>
      </Layout>
    </div>
  );
};

export default Summary;
